import { Box, TextField, Typography } from '@mui/material'
import React, { useEffect } from 'react'

export default function Bloque5({ text5, handleDatosTextField5 }) {

    useEffect(()=>{
        console.log(text5)
    }, [text5])

    return (
        <div style={{ display: "none" }}>
            <Box style={{ marginTop: "50px" }} >
                <Typography style={{ marginBottom: "20px" }} variant="h4" >Campo visual por confrontación</Typography>
                <Box style={{ display: "flex", justifyContent: "space-around" }}>
                    <Box>
                        <Box style={{ textAlign: "center" }}>
                            <Typography variant='h5'>Ojo Iquierdo</Typography>
                        </Box>
                        <Box style={{ display: "flex", flexWrap: "wrap", width: "250px" }}>
                            {
                                text5.filter(y => y.id === 1 || y.id === 2 || y.id === 3 || y.id === 4 || y.id === 5 || y.id === 6 || y.id === 7 || y.id === 8 || y.id === 9).map(x =>
                                       <Box key={x.id} style={{ width: "80px", minHeight: "80px", margintop: "-10px" }}>
                                        <TextField
                                        type={"number"}
                                            
                                            style={{ width: "80px", minHeight: "80px !important" }} 
                                            
                                            onChange={(e) => handleDatosTextField5(x.id, e.target.value, 'ojoi')}
                                        />
                                    </Box>)
                            }

                        </Box>
                    </Box>
                    <Box>
                        <Box style={{ textAlign: "center" }}>
                            <Typography variant='h5'>Ojo Derecho</Typography>
                        </Box>
                        <Box style={{ display: "flex", flexWrap: "wrap", width: "250px" }}>
                            {
                                text5.filter(y => y.id === 10 || y.id === 11 || y.id === 12 || y.id === 13 || y.id === 14 || y.id === 15 || y.id === 16 || y.id === 17 || y.id === 18 || y.id === 19).map(x =>
                                    < Box key={x.id} style={{ width: "80px", minHeight: "80px", margintop: "-10px" }}>
                                        <TextField
                                        type={"number"}
                                            
                                            style={{ width: "80px", minHeight: "80px !important" }} 
                                            
                                            onChange={(e) => handleDatosTextField5(x.id, e.target.value, 'ojod')}
                                        />
                                    </Box>)
                            }

                        </Box>
                    </Box>

                </Box>
            </Box>
        </div >
    )
}
